/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_WaitingInputs */

const th_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รอสัญญาณ`)
};

const en_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

const ja_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待機中`)
};

const zh_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待中`)
};

const es_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperando`)
};

const pt_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aguardando`)
};

const id_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu`)
};

const fr_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const tl_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naghihintay`)
};

const vi_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đợi`)
};

const ko_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대기 중`)
};

const de_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warten`)
};

const ru_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидание`)
};

const tr_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekliyor`)
};

const it_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In attesa`)
};

const pl_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oczekiwanie`)
};

const uk_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очікування`)
};

const hi_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतीक्षा`)
};

const ar_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بالانتظار`)
};

const ms_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu`)
};

const bn_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অপেক্ষা`)
};

const zh_tw2_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待中`)
};

const zh_hk2_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等待中`)
};

const ur_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتظار`)
};

const fa_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در انتظار`)
};

const sw_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inasubiri`)
};

const nl_video_waiting = /** @type {(inputs: Video_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachten`)
};

/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Video_WaitingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_waiting = /** @type {((inputs?: Video_WaitingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_WaitingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_waiting(inputs)
	if (locale === "ja") return ja_video_waiting(inputs)
	if (locale === "zh") return zh_video_waiting(inputs)
	if (locale === "es") return es_video_waiting(inputs)
	if (locale === "pt") return pt_video_waiting(inputs)
	if (locale === "id") return id_video_waiting(inputs)
	if (locale === "fr") return fr_video_waiting(inputs)
	if (locale === "tl") return tl_video_waiting(inputs)
	if (locale === "vi") return vi_video_waiting(inputs)
	if (locale === "ko") return ko_video_waiting(inputs)
	if (locale === "de") return de_video_waiting(inputs)
	if (locale === "ru") return ru_video_waiting(inputs)
	if (locale === "tr") return tr_video_waiting(inputs)
	if (locale === "it") return it_video_waiting(inputs)
	if (locale === "pl") return pl_video_waiting(inputs)
	if (locale === "uk") return uk_video_waiting(inputs)
	if (locale === "hi") return hi_video_waiting(inputs)
	if (locale === "ar") return ar_video_waiting(inputs)
	if (locale === "ms") return ms_video_waiting(inputs)
	if (locale === "bn") return bn_video_waiting(inputs)
	if (locale === "zh-TW") return zh_tw2_video_waiting(inputs)
	if (locale === "zh-HK") return zh_hk2_video_waiting(inputs)
	if (locale === "ur") return ur_video_waiting(inputs)
	if (locale === "fa") return fa_video_waiting(inputs)
	if (locale === "sw") return sw_video_waiting(inputs)
	if (locale === "nl") return nl_video_waiting(inputs)
	return en_video_waiting(inputs)
});